module.exports = __webpack_public_path__ + "img/pullup-side-by-side.217b8206.png";